import purify from "dompurify";

import { Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { NoTouchPurchasePaymentFailure } from "app/components/no-touch-purchase-modal/confirmation-modal/payment-failure/NoTouchPurchasePaymentFailure";
import { NoTouchPurchaseSuccess } from "app/components/no-touch-purchase-modal/confirmation-modal/success/NoTouchPurchaseSuccess";
import { useNoTouchPurchaseQuery } from "app/components/no-touch-purchase-modal/confirmation-modal/useNoTouchPurchaseQuery";
import type { INoTouchAddon } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import { translate } from "app/filters/i18nFilter";
import { Spinner } from "pro-features/components/Loaders/src/Spinner";

const confirmModalStyle: ReactModal.Styles = {
    content: {
        width: "523.5px",
        minHeight: "416px",
        border: 0,
    },
};

interface INoTouchPurchaseConfirmationModalProps {
    selectedAddon?: INoTouchAddon;
    isPaymentFailed?: boolean;
    onClose: () => void;
    onConfirmClick: () => void;
    onPurchaseSuccess: () => void;
    onPurchaseError: () => void;
    onPurchasePaymentError: () => void;
}

export const NoTouchPurchaseConfirmationModal = ({
    selectedAddon,
    isPaymentFailed,
    onClose,
    onPurchaseSuccess,
    onPurchaseError,
    onPurchasePaymentError,
    onConfirmClick,
}: INoTouchPurchaseConfirmationModalProps) => {
    const { isLoading } = useNoTouchPurchaseQuery({
        selectedAddon,
        onPurchaseSuccess,
        onPurchaseError,
        onPurchasePaymentError,
    });

    if (isPaymentFailed) {
        return <NoTouchPurchasePaymentFailure onClose={onClose} />;
    }

    return (
        <Modal
            customStyles={confirmModalStyle}
            isOpen={true}
        >
            <Flex
                flexDirection="column"
                justifyContent="space-between"
                height="100%"
            >
                {isLoading ? (
                    <Flex
                        flexDirection="column"
                        gap="16px"
                        height="100%"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Text
                            fontVariant="body1"
                            textAlign="center"
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                __html: purify.sanitize(
                                    translate(NO_TOUCH_PURCHASE_TRANSLATIONS.success.purchaseInProgress),
                                ),
                            }}
                        />
                        <Spinner />
                    </Flex>
                ) : (
                    <NoTouchPurchaseSuccess onConfirmClick={onConfirmClick} />
                )}
            </Flex>
        </Modal>
    );
};
